import * as React from 'react';
import { Container, Typography, Paper, Alert } from '@mui/material';

interface IComingSoonViewProps {
  heading: string
};

export default function ComingSoonView(props: IComingSoonViewProps) {  
  return (    

    <Paper sx={{ display: 'flex', flexDirection: 'column', width: '100%', height: '100%', justifyContent: 'center' }}>
      <Container component='div' sx={{ display: 'flex', alignItems: 'flex-start' }}>
        <Typography component="h2" variant="h6" sx={{ pt: 2 }} color="primary" gutterBottom>
          {props.heading}
        </Typography>
      </Container>
      <Container component='div' sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%'}}>
        <Alert severity="info" sx={{ width:'175px'}}>Coming soon!</Alert>
      </Container>
    </Paper>
  );
}